export function getOrganizationSchema() {
	return {
		'@context': 'https://schema.org',
		'@type': 'Organization',
		name: 'MyBillingsMethod',
		url: 'https://mybillingsmethod.com',
		logo: 'https://mybillingsmethod.com/logo.png',
		description: 'Privacy-first Billings Method tracking app for Mac',
		foundingDate: '2024',
		contactPoint: {
			'@type': 'ContactPoint',
			email: 'hello@mybillingsmethod.com',
			contactType: 'Customer Support',
			availableLanguage: 'English',
		},
		sameAs: [
			// Add social media links when available
			// 'https://twitter.com/mybillingsmethod',
			// 'https://reddit.com/r/mybillingsmethod'
		],
	}
}

export function getSoftwareApplicationSchema() {
	return {
		'@context': 'https://schema.org',
		'@type': 'SoftwareApplication',
		name: 'MyBillingsMethod',
		operatingSystem: 'macOS',
		applicationCategory: 'HealthApplication',
		offers: {
			'@type': 'Offer',
			price: '29',
			priceCurrency: 'GBP',
			availability: 'https://schema.org/PreOrder',
			priceValidUntil: '2026-04-30',
			description: 'Beta pricing for first 100 users',
		},
		description:
			'Privacy-first Billings Ovulation Method tracking app with AI-powered insights. All data stored locally on your Mac.',
		featureList: [
			'Billings Method charting',
			'Local-only storage',
			'AI pattern recognition',
			'Instructor-ready exports',
			'Partner access',
		],
		releaseNotes: 'Beta launch April 2026',
	}
}

export function getWebPageSchema(
	pageTitle: string,
	pageDescription: string,
	pageUrl: string,
) {
	return {
		'@context': 'https://schema.org',
		'@type': 'WebPage',
		name: pageTitle,
		description: pageDescription,
		url: pageUrl,
		inLanguage: 'en-GB',
		publisher: {
			'@type': 'Organization',
			name: 'MyBillingsMethod',
			logo: {
				'@type': 'ImageObject',
				url: 'https://mybillingsmethod.com/logo.png',
			},
		},
	}
}

export function getFAQSchema() {
	return {
		'@context': 'https://schema.org',
		'@type': 'FAQPage',
		mainEntity: [
			{
				'@type': 'Question',
				name: 'What is the Billings Method?',
				acceptedAnswer: {
					'@type': 'Answer',
					text: 'The Billings Ovulation Method is a natural family planning method that tracks cervical mucus patterns to identify fertile and infertile days. It requires no devices and is 98-99% effective when practiced correctly.',
				},
			},
			{
				'@type': 'Question',
				name: 'Is my data really private?',
				acceptedAnswer: {
					'@type': 'Answer',
					text: 'Yes. MyBillingsMethod stores all data locally on your Mac. No cloud servers, no syncing, no tracking. Your fertility data physically cannot leave your device. Privacy by architecture.',
				},
			},
			{
				'@type': 'Question',
				name: 'When does the app launch?',
				acceptedAnswer: {
					'@type': 'Answer',
					text: 'MyBillingsMethod launches in April 2026. Beta users (first 100) can reserve access now at £29/year for life.',
				},
			},
			{
				'@type': 'Question',
				name: 'Do I need a thermometer?',
				acceptedAnswer: {
					'@type': 'Answer',
					text: 'No. The Billings Method tracks only cervical mucus, so no thermometer is required. This saves £20-100 on devices and works with irregular schedules.',
				},
			},
		],
	}
}
